<template>
  <div class="overflow-y-scroll">
    <section>
      <div class="form-inline">
        <label>File:</label>
        <div class="input-group">
          <div class="input-file">
            <input type="file" @change="onFileChange($event)" />
            <label class="custom-file-label">{{
              editFileName ? editFileName : "Choose file"
            }}</label>
          </div>
        </div>
      </div>
      <div class="form-inline flex-row">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
          >Upload Resume</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
// import axios from "axios";
// import * as database from "@/vendor/database";
import spinnerButton from "@/components/public/SpinnerButton";
import { storagePut, storageGetDownloadUrl } from "@/vendor/firebase";
import { randomString } from "@/utils/utils";
import { httpGet } from "@/http/http";

export default {
  props: ["propsData"],
  components: {
    spinnerButton,
  },
  data() {
    return {
      submitLoading: false,
      editId: null,
      editFileName: null,
      editFile: null,
      editFileData: null,
    };
  },
  created: function () {
    this.initData();
  },
  watch: {
    propsData: function () {
      this.initData();
    },
  },
  methods: {
    initData: function () {
      this.editId = this.propsData;
      this.editFileName = null;
      this.editFile = null;
      this.editFileData = null;
    },
    onFileChange: function (event) {
      const file = event.target.files[0];
      if (file) {
        this.editFileName = file.name;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (arg) => {
          this.editFile = file;
          this.editFileData = arg.target.result;
        };
      }
    },
    buttonClick: async function () {
      try {
        this.submitLoading = true;
        const array = this.editFileName.split(".");
        const fileType = array.length > 1 ? "." + array[array.length - 1] : "";
        const fileName = "resume_" + randomString(10) + fileType;
        await storagePut(
          `consultants/${this.editId}/`,
          fileName,
          this.editFile
        );
        const getResult = await storageGetDownloadUrl(
          `consultants/${this.editId}/${fileName}`
        );
        const fileUrl = getResult.data;
        await httpGet("upload_resume", { consultantId: this.editId, fileUrl })
          .then((result) => {
            if (result.ok) {
              this.$toasted.global.toast_success({
                message: "upload success",
              });
              this.$emit("closePanel");
            } else {
              this.$toasted.global.toast_error({ message: "upload error" });
            }
          })
          .catch((error) => {
            this.$toasted.global.toast_error({ message: error });
          })
          .finally(() => {
            this.submitLoading = false;
          });
      } catch {
        this.submitLoading = false;
        this.$toasted.global.toast_error({ message: "error" });
      }
      this.submitLoading = false;
    },
  },
};
</script>
